import { ABB_PRODUCT_NAME_LOCALIZED_KEY, STORY_BODY_A_KEY } from '@yme/selectors/constants';
import { getAttributeByName } from '@yme/selectors/helpers';
import { checkBoatsProductType, checkEBikesProductType, checkMarineEngineProductType, checkMotorcyclesProductType, checkScooterProductType, } from '@yme/utils/productTypes';
export function isProductCardEmpty() {
    return true;
}
export function getLabels(labels) {
    const { productCard_productDescription_label: productDescriptionLabel = '', productCard_gallery_label: galleryLabel = '', productCard_expandGalleryButton_alt: expandGalleryButtonAlt = '', productCard_previousItemGalleryButton_alt: previousItemGalleryButtonAlt = '', productCard_nextItemGalleryButton_alt: nextItemGalleryButtonAlt = '', productCard_closeGalleryButton_alt: closeGalleryButtonAlt = '', productCard_addToCartButton_label: addToCartButtonLabel = '', productCard_outOfStockButton_label: outOfStockButtonLabel = '', productCard_requestTestRideButton_label: requestTestRideButtonLabel = '', productCard_360viewEnterButton_label: view360EnterButtonLabel = '', productCard_360viewExitButton_label: view360ExitButtonLabel = '', productCard_360viewLoading_text: view360LoadingText = '', productCard_360view_hint: view360Hint = '', productCard_downloadImageButton_label: downloadImageButtonLabel = '', } = labels;
    return {
        // General Label
        productDescriptionLabel,
        // Gallery Labels
        galleryLabel,
        expandGalleryButtonAlt,
        previousItemGalleryButtonAlt,
        nextItemGalleryButtonAlt,
        closeGalleryButtonAlt,
        downloadImageButtonLabel,
        // Labels for Cart section
        addToCartButtonLabel,
        outOfStockButtonLabel,
        requestTestRideButtonLabel,
        // view 360 labels
        view360EnterButtonLabel,
        view360ExitButtonLabel,
        view360LoadingText,
        view360Hint,
    };
}
export function getDescriptionProps({ productCardData, productDescriptionLabel, customProductTitle, }) {
    return {
        image: productCardData.studioImage,
        label: productDescriptionLabel,
        title: customProductTitle || productCardData?.titleAttribute?.value,
        description: productCardData?.descriptionAttribute?.value,
    };
}
export function getProductImagesByIndex(data, sku, index = 0) {
    const product = data ? data[index]?.variantsOfProduct : [];
    return product?.find((product) => product.sku === sku)?.images;
}
// Helpers for selectors
export function getTitleAttribute(data) {
    return data?.attributes.find(getAttributeByName(ABB_PRODUCT_NAME_LOCALIZED_KEY));
}
export function getDescriptionAttribute(data) {
    return data?.attributes.find(getAttributeByName(STORY_BODY_A_KEY));
}
export function getPriceAttribute(data) {
    return data?.prices[0];
}
export function getLowestPriceAttribute(data) {
    return data.length > 0
        ? data.reduce((prev, curr) => (prev?.amount < curr?.amount ? prev : curr))
        : undefined;
}
export function getFilterOptionByProductType({ productVariantsByColor, colorItemIndex, }) {
    const currentProductType = productVariantsByColor && productVariantsByColor[colorItemIndex]?.productType;
    const isMarineEnginesFilter = checkMarineEngineProductType(currentProductType);
    const isEBikesFilter = checkEBikesProductType(currentProductType);
    const isMotorcyclesFilter = checkMotorcyclesProductType(currentProductType);
    const isScootersFilter = checkScooterProductType(currentProductType);
    const isBoatsFilter = checkBoatsProductType(currentProductType);
    const isDefaultFilter = !isMarineEnginesFilter && !isEBikesFilter && !isMotorcyclesFilter && !isBoatsFilter;
    return {
        isMarineEnginesFilter,
        isEBikesFilter,
        isMotorcyclesFilter,
        isDefaultFilter,
        isScootersFilter,
        isBoatsFilter,
    };
}
export function composePageTitle({ productName, categoryTitle, brandSlug, pageTitle, }) {
    return `${productName || pageTitle}${categoryTitle ? ` - ${categoryTitle}` : ''}${brandSlug ? ` - ${brandSlug}` : ''}`;
}
